import { toast } from 'react-toastify';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { submitApplication } from '../../../utilities/API/applicationSubmitServices';

export const applicationSubmission = createAsyncThunk(
    'submitApplication', submitApplication
)

const initialState = {
   program:'',
   patientId:'',
   AppId:'',
   updatePatientData: false,
   ApplicationConfirmationMessage:'',
}

const applicationSubmissionSlice = createSlice({
    name: 'fundSpecificLookupSlice',
    initialState,
    reducers:{
        setUpdatePatientData:(state, action) =>{
            state.updatePatientData = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(applicationSubmission.pending, (state, action) => {
                // toast.warn("PreQualQuestions pending")
            })
            .addCase(applicationSubmission.fulfilled, (state, action) => {
                let response = action.payload.res
                if(response?.ResponseDetails?.ResponseCode == "010"){
                    state.program = action.payload.program;
                    state.patientId = response.PatientID;
                    state.AppId = response.ApplicationID;
                    state.updatePatientData = true
                    // toast.success(response.ApplicationID)
                }else{
                    toast.warn(response?.ResponseDetails?.ResponseMessage);
                }
            })
            .addCase(applicationSubmission.rejected, (state, action) => {
                // toast.error(action.error.message)
            })
    },
})

export const { setUpdatePatientData } = applicationSubmissionSlice.actions
export default applicationSubmissionSlice.reducer